var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeview(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 14,
    viewBox: "0 0 21 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0157 2.33189C13.486 2.33189 16.6574 4.09039 18.5072 7.03839C16.6575 9.98639 13.4861 11.7449 10.0157 11.7449C6.54527 11.7449 3.37367 9.98609 1.52408 7.03859C3.37367 4.09059 6.54517 2.33189 10.0157 2.33189ZM10.0157 0.831787C5.88337 0.831787 2.26478 3.00979 0.230875 6.27739C-0.056125 6.73829 -0.056125 7.33839 0.230875 7.79959C2.26478 11.0669 5.88337 13.2449 10.0157 13.2449C14.148 13.2449 17.7664 11.0669 19.8004 7.79959C20.0874 7.33839 20.0874 6.73829 19.8004 6.27739C17.7665 3.00979 14.1478 0.831787 10.0157 0.831787Z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0156 9.83439C11.5597 9.83439 12.8115 8.58262 12.8115 7.03849C12.8115 5.49435 11.5597 4.24259 10.0156 4.24259C8.47144 4.24259 7.21967 5.49435 7.21967 7.03849C7.21967 8.58262 8.47144 9.83439 10.0156 9.83439Z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeview);
export default __webpack_public_path__ + "static/media/eyeview.4653cd370de05722a869ee8aac287e7c.svg";
export { ForwardRef as ReactComponent };